<template>
    <h1>You have no privileges </h1>
</template>